"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const VagueNode_1 = require("./VagueNode");
function mergePatches(patches) {
    const root = new VagueNode_1.VagueNode('');
    for (let i = 0; i < patches.length; i++) {
        const patch = patches[i];
        const node = root.queryPath(patch.path);
        node.applyPatch('', patch);
    }
    return Array.from(root.toPatches(''));
}
exports.default = mergePatches;
